import * as React from 'react';
import { useState } from "react";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import {api} from "../../../../../utils/axios";
import "../../../styles/rosterUpload.css";

interface Props {
    clientId: string;
}

const RosterRefreshBilling: React.FC<Props> = ({ clientId }) => {
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState<string | null>(null);

    const handleRefresh = async () => {
        setLoading(true);
        setMessage(null);

        try {
            const response = await api.post("/admin/rosters/refresh-billing", {
                client_id: clientId,
            });
            const { inserted, message: resultMsg } = response.data;
            setMessage(`✅ ${inserted} records inserted. ${resultMsg}`);
        } catch (error) {
            console.error("Refresh billing failed", error);
            setMessage("❌ Refresh billing failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box className="roster-upload-container">
            <Typography variant="h5" gutterBottom>
                Refresh Billing Tracker
            </Typography>

            <Button
                variant="contained"
                color="primary"
                onClick={handleRefresh}
                disabled={loading}
            >
                Refresh Billing Now
            </Button>

            {loading && <CircularProgress sx={{ mt: 2 }} />}
            {message && <Typography sx={{ mt: 2 }} color="primary">{message}</Typography>}
        </Box>
    );
};

export default RosterRefreshBilling;
